export default __webpack_public_path__ + "static/WWLFImage-mobile-87e3b9db15c876feb4560fc2b218bd34.png";